import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Spinner } from 'react-bootstrap';
import { Table } from '@rd-web-markets/shared/dist/util';
import { DownloadButton, Button } from '@rd-web-markets/shared/dist/util/buttons';
import TemplateUploadErrorsModal from '@rd-web-markets/shared/dist/util/files/TemplateUploadErrorsModal';
import { formatDateTimeLocaleWithTime } from '@rd-web-markets/shared/dist/util/date/dateUtils';
const STATUS_CONFIG = {
  never_imported: {
    bg: 'secondary',
    textKey: 'never_imported'
  },
  pending: {
    bg: 'warning',
    textKey: 'pending'
  },
  imported_successfully: {
    bg: 'success',
    textKey: 'imported_successfully'
  },
  imported_unsuccessfully: {
    bg: 'danger',
    textKey: 'imported_unsuccessfully'
  }
};
const ClaimTemplateImportsTable = _ref => {
  let {
    imports = [],
    loading
  } = _ref;
  const {
    t
  } = useTranslation();
  const [errorModalImport, setErrorModalImport] = useState(null);
  const getStatusBadge = status => {
    const config = STATUS_CONFIG[status] || STATUS_CONFIG.never_imported;
    return /*#__PURE__*/React.createElement(Badge, {
      bg: config.bg,
      style: {
        fontWeight: 'normal',
        fontSize: '0.75em',
        opacity: 0.85
      }
    }, t(config.textKey), status === 'pending' && /*#__PURE__*/React.createElement(Spinner, {
      as: "span",
      animation: "border",
      size: "sm",
      role: "status",
      "aria-hidden": "true",
      className: "ms-2"
    }));
  };
  const headers = useMemo(() => [{
    text: t('type'),
    width: '10%'
  }, {
    text: t('status'),
    width: '15%'
  }, {
    text: t('imported_by'),
    width: '20%'
  }, {
    text: t('imported_at'),
    width: '20%'
  }, {
    text: t('time_elapsed'),
    width: '10%'
  }, {
    text: '',
    width: '35%'
  }], [t]);
  const rows = useMemo(() => {
    return imports.map(importItem => ({
      key: importItem.id + '_' + importItem.import_type,
      columns: [/*#__PURE__*/React.createElement("small", {
        className: "text-muted text-capitalize"
      }, importItem.import_type), getStatusBadge(importItem.import_status), /*#__PURE__*/React.createElement("small", null, importItem.imported_by || '-'), /*#__PURE__*/React.createElement("small", null, formatDateTimeLocaleWithTime(importItem.created_at) || '-'), importItem.elapsed_seconds != null ? /*#__PURE__*/React.createElement("small", null, importItem.elapsed_seconds, "s") : /*#__PURE__*/React.createElement("small", {
        className: "text-muted"
      }, "-"), /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-end gap-2"
      }, importItem.import_status === 'imported_unsuccessfully' && importItem.import_messages?.length > 0 && /*#__PURE__*/React.createElement("span", {
        role: "button",
        className: "text-danger text-decoration-underline",
        style: {
          cursor: 'pointer',
          fontSize: '0.85em'
        },
        onClick: () => setErrorModalImport(importItem)
      }, t('show_errors')), importItem.download_link && /*#__PURE__*/React.createElement(DownloadButton, {
        size: "sm",
        variant: "info",
        onClick: () => window.open(importItem.download_link.url, '_blank')
      }, t('download')))]
    }));
  }, [imports, t]);
  const errorModalBody = errorModalImport && /*#__PURE__*/React.createElement(Table, {
    headers: [{
      text: t('error')
    }],
    rows: errorModalImport.import_messages.map((err, idx) => ({
      key: idx,
      columns: [/*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, err.message)]
    })),
    showControls: false
  });
  if (imports.length === 0 && !loading) {
    return /*#__PURE__*/React.createElement("p", {
      className: "text-muted text-center py-4"
    }, t('no_imports_yet'));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TemplateUploadErrorsModal, {
    title: t('import_errors'),
    body: errorModalBody,
    show: !!errorModalImport,
    onHide: () => setErrorModalImport(null)
  }), /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    showControls: false,
    opts: {
      bordered: false,
      striped: true,
      responsive: true,
      hover: true,
      headerSticky: true
    },
    style: {
      borderCollapse: 'collapse'
    }
  }));
};
export default ClaimTemplateImportsTable;